import type { BrandThemeConfig, ResolvedTheme } from './theme.interface';

export const defaultTheme: BrandThemeConfig = {
    name: 'Fleets',
    mode: 'light',
    brand: {
        primary: {
            0: '#6C8EEF',
            100: '#D1DDFF',
            200: '#EEF2FF',
        },
        green: {
            0: '#01EA74',
            100: '#CBFFE5',
            200: '#92F9C5',
            300: '#D7F7C2',
            400: '#006908',
        },
        dark: {
            0: '#3F4D70',
            100: '#536288',
            200: '#6E7B9C',
            300: '#1A1F36',
        },
        white: {
            0: '#FFFFFF',
            100: '#F5F5F5',
            200: '#E5E5E5',
            300: '#D4D4D4',
            400: '#C4C4C4',
            500: '#B3B3B3',
            600: '#A2A2A2',
        },
        yellow: {
            0: '#FFD875',
            100: '#FFEBA6',
            200: '#E5A500',
            300: '#FDE89E',
        },
        orange: {
            0: '#FF8F0E',
            100: '#FCBD3A',
            200: '#FCEDB9',
        },
        blue: {
            0: '#3883FF',
            100: '#C0D8FF',
        },
        purple: {
            0: '#6C8EEF',
            100: '#D1DDFF',
        },
        red: {
            0: '#FF426F',
            100: '#FFBDD1',
        },
        neutral: {
            0: '#C9D6E8',
            100: '#D3DFEE',
            200: '#E1E8F1',
            300: '#F2F8FF',
            400: '#F2F8FF',
        },
        gray: {
            0: '#687385',
            100: '#EBEEF1',
            200: '#A3ACBA',
            300: '#F6F8FA',
            400: '#D8DEE4',
            500: '#F7F8F9',
        },
        fontFamily: 'Montserrat',
        padding: {
            none: 0,
            sm: 4,
            md: 8,
            lg: 12,
            xl: 16,
            2: 20,
            3: 24,
            4: 28,
            5: 32,
            6: 36,
            7: 40,
            8: 44,
            9: 48,
        },
        margin: {
            none: 0,
            sm: 4,
            md: 8,
            lg: 12,
            xl: 16,
            2: 20,
            3: 24,
            4: 28,
            5: 32,
            6: 36,
            7: 40,
            8: 44,
            9: 48,
        },
        radius: {
            sm: 4,
            md: 8,
            lg: 12,
            xl: 16,
            2: 20,
            3: 24,
            4: 28,
            5: 32,
            6: 36,
            7: 40,
            8: 44,
            9: 48,
        },
    },
    components: {},
};

export const resolveMode = (
    preferred: 'light' | 'dark' | 'system',
): 'light' | 'dark' => {
    if (preferred === 'system') {
        if (
            typeof window !== 'undefined'
			&& window.matchMedia
			&& window.matchMedia('(prefers-color-scheme: dark)').matches
        ) {
            return 'dark';
        }
        return 'light';
    }
    return preferred;
};

export const resolveTheme = (input?: BrandThemeConfig): ResolvedTheme => {
    const merged: BrandThemeConfig = {
        ...defaultTheme,
        ...(input || {}),
        brand: {
            ...defaultTheme.brand,
            ...(input?.brand || {}),
        },
        components: {
            ...defaultTheme.components,
            ...(input?.components || {}),
        },
    };

    const mode = resolveMode(merged.mode || 'system');

    return {
        mode,
        brand: merged.brand,
        components: merged.components,
    };
};
